import { Controller } from "@hotwired/stimulus"
import { createConsumer } from "@rails/actioncable"

// Connects to data-controller="waiting-room"
export default class extends Controller {
  
  static values = { clinicId: Number }

  connect() {
    this.channel = createConsumer().subscriptions.create(
      { channel: "WaitingRoomChannel", clinic_id: this.clinicIdValue },
      {
        received: (data) => {
          if (data.action === "arrival") this.playArrivalSound()
          // if (data.action === "departure") this.playDepartureSound()
        }
      }
    )
  }

  playArrivalSound() {
    const audio = new Audio("/audio/bell.wav")
    audio.play()
  }

  playDepartureSound() {
    const audio = new Audio("/audio/door-close.wav")
    audio.play()
  }

  disconnect() {
    this.channel?.unsubscribe()
  }
  
}